import * as React from 'react';

/**
 * Shared full-screen, centered layout used by the unauthenticated auth pages
 * (login / register / accept invitation). It has no side menu.
 */
export class AuthCard extends React.Component<Props, {}> {

    public render() {
        return (
            <div style={{ width: '100%', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8f8f8', padding: '32px' }}>
                <div style={{ width: '420px', backgroundColor: '#fff', padding: '32px', boxShadow: '1px 1px 16px rgba(0,0,0,0.3)' }}>
                    <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                        <i className="material-icons" style={{ fontSize: '48px', color: '#009155', verticalAlign: 'middle' }}>account_circle</i>
                        <span style={{ fontSize: '28px', fontWeight: 100, color: '#004126', verticalAlign: 'middle', marginLeft: '8px' }}>Humen</span>
                    </div>
                    {this.props.title && (
                        <div style={{ fontSize: '20px', fontWeight: 900, color: '#333', marginBottom: '24px', textAlign: 'center' }}>{this.props.title}</div>
                    )}
                    {this.props.error && (
                        <div style={{ fontSize: '15px', fontWeight: 400, color: '#c00', marginBottom: '24px', textAlign: 'center' }}>{this.props.error}</div>
                    )}
                    {this.props.children}
                </div>
            </div>
        );
    }

}

export interface Props {

    title?: string;
    error?: string;
    children?: React.ReactNode;

}
